export const jobOpenings = [
  {
    id: "pm-ai-platforms", // Use a string ID for consistency
    title: "Product Manager - AI Platforms",
    department: "Product",
    location: "Boston, MA / Remote",
    type: "Full-time",
    shortDescription:
      "Own the roadmap and feature definition for our core AI modernization products...", // Existing short description
    fullDescription:
      "LoyalShift is seeking an experienced Product Manager to lead the strategy, roadmap, and execution for our core AI-driven modernization platform. You will work closely with engineering, sales, and marketing to define innovative features, prioritize development, and ensure our solutions deliver maximum value in overcoming legacy system challenges for enterprise clients.",
    responsibilities: [
      "Define and own the product vision, strategy, and roadmap for AI platform components.",
      "Translate business requirements and market needs into detailed technical specifications and user stories.",
      "Prioritize features and backlog based on customer value, business objectives, and technical feasibility.",
      "Collaborate daily with engineering teams using Agile methodologies.",
      "Conduct market research, competitive analysis, and customer interviews.",
      "Work with marketing and sales to define go-to-market strategies and support collateral.",
      "Analyze product performance data and user feedback to iterate and improve.",
    ],
    qualifications: [
      "5+ years of product management experience, preferably with B2B SaaS or AI/ML platforms.",
      "Proven track record of launching successful technical products from ideation to launch.",
      "Strong understanding of AI/ML concepts and their application to business problems.",
      "Experience working with complex enterprise systems (e.g., ERP, CRM, legacy databases) is a plus.",
      "Excellent communication, presentation, and interpersonal skills.",
      "Ability to influence cross-functional teams without formal authority.",
      "Bachelor's degree in Computer Science, Engineering, Business, or related field (MBA preferred).",
    ],
    benefits: [
      "Competitive salary and stock options.",
      "Comprehensive health, dental, and vision insurance.",
      "Generous paid time off and holidays.",
      "401(k) plan with company match.",
      "Professional development budget.",
      "Remote work flexibility.",
      "Opportunity to work on cutting-edge AI technology with significant impact.",
    ],
    applyLink: "/contact?applicationFor=pm-ai-platforms", // Example link to a contact form or external ATS
  },
];
